export const MODAK_URL = 'https://modakmakers.com';
export const SPLIT_BILLS_URL = 'https://modakmakers.typeform.com/to/VBNw2O6W';
